import { FlowStep } from 'src/components/flows/types'

import { createFieldValidator, FieldValidatorProps } from '../form/field-validators'

export type LakehouseFlowFieldValidatorProps = FieldValidatorProps & {
  stepId: string
}

export const lakehouseFlowFieldValidator = ({
  stepId,
  validator,
  asyncValidator,
  listenTo,
  ignoreEvents,
}: LakehouseFlowFieldValidatorProps) => {
  return createFieldValidator(
    { validator, asyncValidator, listenTo, ignoreEvents },
    {
      shouldValidate: (fieldApi: any) => {
        const flowSteps = fieldApi.form.state.values.flowSteps as FlowStep<any>[]
        const currStepIndex = fieldApi.form.state.values.currStepIndex
        const flowIndex = flowSteps.findIndex((step: FlowStep<any>) => step.id === stepId)
        return flowIndex <= currStepIndex
      },
    },
  )
}
